<template>
  <div class="site-logo">
    <router-link class="center" :to="toPath">
      <img :src="darkLogo" alt="site logo" style="margin-top:8px;padding-left:8px;height: 35px;" v-if="sidebarSelectedFilter.class === 'sidebar-overlay-light'">
      <img class="appLogo" :src="appLogo" alt="site logo" style="margin-top:8px;padding-left:8px;height:23px" :style="{height: $targetMake.isSeller ? '23px' : '23px'}" v-else>
      <img class="appIcon" :src="$targetMake.images.appIcon" alt="mobile logo" width="40" height="40">
    </router-link>
    <div class="adminHeader" v-if="isAdministratorRole">
      <div class="divider"></div>
      <i class="UXicon-wrench"></i>
      <span>管理者センター</span>
    </div>
  </div>
</template>

<script>
import AppConfig from 'constants/AppInfo'
import {mapGetters} from 'vuex'
import Util from '@/util'

export default {
  computed: {
    ...mapGetters(['sidebarSelectedFilter',
      'isAdministratorRole']),
    toPath () {
      if (this.isAdministratorRole) {
        return '/adminDashboard'
      } else {
        return '/dashboard'
      }
    }
  },
  data () {
    return {
      appLogo: this.$targetMake.isSeller ? AppConfig.appSgLogo : AppConfig.appCgLogo,
      darkLogo: this.$targetMake.isSeller ? AppConfig.darkSgLogo : AppConfig.darkCgLogo
    }
  },
  created () {
    this.$store.commit('SET_DATA', { key: 'isAdministratorRole', boolean: localStorage.getItem('token') && Util.parseLoginToken().admin })
  }
}
</script>
<style lang="scss">
  .appIcon {
    display: none;
  }
  @media all and (max-width:600px) {
    .appIcon {
      display: block;
    }
    .appLogo {
      display: none;
    }
    .center {
      margin: 0 auto;
    }
  }
  .site-logo {
    .adminHeader {
      .divider {
        height: 20px;
        border-left: 1px solid #E8E8E8;
        margin-left: 15px;
        margin-right: 15px;
      }
      display: flex;
      align-items: center;
      font-weight: bold;
      i {
        margin-right: 6px;
        font-size: 22px;
      }
      span {
        font-size: 16px;
        height: 22px;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/header/fragments/app_logo.vue